<form [formGroup]="searchFilterForm">
    <!--Searchbar-->
    <div class="row">
        <div class="col-12">
            <div class="d-flex mb-2 px-1 autocomplete">
                <ng-autocomplete #autoComplete placeholder="Cerca..." [data]="storesSuggestion"
                    [searchKeyword]="storeKeyword" (selected)='selectStoreEvent($event)'
                    (inputChanged)='getStoresList($event)' (inputFocused)='onStoreFocused($event)'
                    [itemTemplate]="itemStoreTemplate" (inputCleared)="searchStoreCleared()"
                    [notFoundTemplate]="notFoundStoresTemplate" [debounceTime]="600"
                    [isLoading]="isStoreKeywordLoadingResult" [minQueryLength]="0">
                </ng-autocomplete>
                <ng-template #itemStoreTemplate let-item>
                    <div class="row">
                        <div class="col-10">
                            <span [innerHTML]="item.titleSeo"></span>
                        </div>
                    </div>
                </ng-template>

                <ng-template #notFoundStoresTemplate let-notFound>
                    {{errorMsg}}
                </ng-template>
            </div>
        </div>
    </div>

    <!-- Filters -->
    <div class="row">

        <div class="col-lg-10 col-md-12 col-sm-12 col-xs-12">
            <div [ngClass]="storeSelected.length > 0  ? '': 'disabled-click'">
                
                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 p-1 inlineflex-md">
                    <div class="form-check pl-0 mx-1 pb-3 form-check-inline">
                        <label class="form-check-label text fw-normal size16">
                            Data prenotazione:
                        </label>
                    </div>
                    <input formControlName="searchFilterField_reserved" (change)="filterReserved()" type="date"
                        class="form-date-fw mr-1">
                </div>
                
                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 p-1 inlineflex-md">
                    <div class="form-check mx-1 pl-0 pb-3 form-check-inline">
                        <label class="form-check-label text fw-normal size16">
                            Data ritiro:
                        </label>
                    </div>
                    <input formControlName="searchFilterField_completed" (change)="filterCompleted()" type="date"
                        class="form-date-fw mr-1">
                </div>

                <div class="col-12 align-items-center">
                    <div [ngClass]="storeSelected.length > 0  ? '': 'disabled-click'" class="col-10 align-items-center">
                        <div class="form-check mx-1 pb-3 form-check-inline mr-6">
                            <input value="searchFilterField_reservedCheck" name="checkboxFilter" class="form-check-input checkboxes"
                                (change)="toggleCheckBoxes('searchFilterField_reservedCheck')" type="checkbox"
                                id="reservedCheckbox">
                            <label class="form-check-label text fw-normal size16 mr-1" for="reservedCheckbox">
                                Confermato
                            </label>
                        </div>
            
                        <div class="form-check pb-3 form-check-inline mr-6">
                            <input value="searchFilterField_completedCheck" name="checkboxFilter"
                                class="form-check-input checkboxes" (change)="toggleCheckBoxes('searchFilterField_completedCheck')"
                                type="checkbox" id="completedCheckbox">
                            <label class="form-check-label text fw-normal size16" for="completedCheckbox">
                                Completato
                            </label>
                        </div>
            
                        <div class="form-check mx-1 pb-3 form-check-inline mr-6">
                            <input value="searchFilterField_pendingCheck" name="checkboxFilter" class="form-check-input checkboxes"
                                (change)="toggleCheckBoxes('searchFilterField_pendingCheck')" type="checkbox">
                            <label class="form-check-label text fw-normal size16 mr-1">
                                Pending
                            </label>
                        </div>
            
                        <div class="form-check pb-3 form-check-inline mr-6">
                            <input value="searchFilterField_cancelledCheck" name="checkboxFilter"
                                class="form-check-input checkboxes" (change)="toggleCheckBoxes('searchFilterField_cancelledCheck')"
                                type="checkbox">
                            <label class="form-check-label text fw-normal size16">
                                Annullato
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 text fw-normal size16 txt-remove">
            <span class="clickable" (click)="clickButtonClearFilter()"> Rimuovi filtri</span>
        </div>
    </div>

    <div class="row">
        <!-- Riga selezioni -->
        <div class="col-lg-10 col-md-12 col-sm-12 col-xs-12"></div>
        <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 text fw-normal size15 txt-remove clickable" (click)="goToList()">
            Mostra come lista
        </div>
    </div>
</form>



<ng-template #headerTemplate let-days="days" let-locale="locale" let-dayClicked="dayClicked"
    let-eventDropped="eventDropped">
    <div class="cal-day-headers cursor-default">
        <div class="cal-header" *ngFor="let day of days" [class.cal-past]="day.isPast" [class.cal-future]="day.isFuture"
            [class.cal-drag-over]="day.dragOver" (mwlClick)="dayClicked.emit({date: day.date})" mwlDroppable
            (dragEnter)="day.dragOver = true" (dragLeave)="day.dragOver = false"
            (drop)="day.dragOver = false; eventDropped.emit({event: $event.dropData.event, newStart: day.date, fromHeader: true})">
            <div class="top" [class.today]="day.isToday">
                <div class="day-label text-uppercase">
                    {{ day.date | calendarDate:'weekViewColumnSubHeader':locale }}
                </div>
                <div class="day-number"> {{ day.date | calendarDate:'weekViewColumnHeader':locale }}</div>
            </div>
        </div>
    </div>
</ng-template>

<!--Page Content-->
<div class="text-center calendar-div">
    <div class="row text-center btn-groups">
        <div class="col-md-4">
            <h3 class="months">{{ viewDate | calendarDate:(view + 'ViewTitle'):locale:weekStartsOn }}</h3>
        </div>
        <div class="col-md-4">
            <div>
                <div class="btn btn-primary buttonew" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate"
                    (viewDateChange)="closeOpenMonthViewDay()">
                    < </div>
                        <div class="btn btn-outline-secondary today" mwlCalendarToday [(viewDate)]="viewDate">
                            Attuale
                        </div>
                        <div class="btn btn-primary buttonew" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate"
                            (viewDateChange)="closeOpenMonthViewDay()">
                            >
                        </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="btn-groups">
                    <div class="btn btn-primary button-view" (click)="setView(CalendarView.Month)"
                        [class.active]="view === CalendarView.Month">
                        Mese
                    </div>
                    <div class="btn btn-primary button-view" (click)="setView(CalendarView.Week)"
                        [class.active]="view === CalendarView.Week">
                        Settimana
                    </div>
                    <div class="btn btn-primary button-view" (click)="setView(CalendarView.Day)"
                        [class.active]="view === CalendarView.Day">
                        Giorno
                    </div>
                </div>
            </div>
        </div>
        <br />
        <ng-template #headerTemplate let-days="days" let-locale="locale" let-dayClicked="dayClicked"
            let-eventDropped="eventDropped">
        </ng-template>



        <div [ngSwitch]="view">
            <mwl-calendar-month-view *ngSwitchCase="CalendarView.Month" [viewDate]="viewDate"
                [weekStartsOn]="weekStartsOn" [events]="events" [locale]="locale" [refresh]="refresh"
                [activeDayIsOpen]="activeDayIsOpen" (dayClicked)="dayClicked($event.day)"
                (eventClicked)="handleEvent('weekClick', $event.event)">
            </mwl-calendar-month-view>
            <mwl-calendar-week-view [headerTemplate]="headerTemplate" *ngSwitchCase="CalendarView.Week"
                [viewDate]="viewDate" [locale]="locale" [weekStartsOn]="weekStartsOn" [events]="events"
                [eventTemplate]="eventTemplate" [hourSegments]="2" [dayStartHour]="8" [dayEndHour]="20"
                [refresh]="refresh" (eventClicked)="handleEvent('weekClick', $event.event)">
            </mwl-calendar-week-view>
            <mwl-calendar-day-view *ngSwitchCase="CalendarView.Day" [viewDate]="viewDate" [locale]="locale"
                [weekStartsOn]="weekStartsOn" [events]="events" [hourSegments]="2" [dayStartHour]="8" [dayEndHour]="20"
                [refresh]="refresh" (eventClicked)="handleEvent('weekClick', $event.event)">
            </mwl-calendar-day-view>
        </div>
    </div>